/* STUDIO DÉCO — FAVORIS V3 : cartes harmonisées, stockage local inchangé */
(() => {
  'use strict';
  const KEY = 'sd-favorites-v1';
  const URL_KEY = 'sd-favorites-urls-v1';
  let renderSequence = 0;

  function read(key, fallback) {
    try { return JSON.parse(localStorage.getItem(key)) || fallback; }
    catch (e) { return fallback; }
  }
  function getFavorites() {
    const value = read(KEY, []);
    return Array.isArray(value) ? value.map(String) : [];
  }
  function getUrls() {
    const value = read(URL_KEY, {});
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  }
  function save(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (e) { console.warn('SD : sauvegarde impossible', e); return false; }
  }
  function syncButtons() {
    const favorites = new Set(getFavorites());
    document.querySelectorAll('[data-sd-favorite]').forEach(button => {
      const active = favorites.has(String(button.dataset.productId));
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Retirer des favoris : ' : 'Ajouter aux favoris : ') + (button.dataset.productTitle || 'ce tapis'));
      button.title = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    });
  }
  function toggle(button) {
    if (!document.body.classList.contains('customer-logged-in')) {
        const returnUrl = window.location.pathname + window.location.search;
  window.location.href = '/account/login?return_url=' +
    encodeURIComponent(returnUrl);
  return;
}
    const id = String(button.dataset.productId || '');
    if (!id) return;
    const favorites = getFavorites();
    const exists = favorites.includes(id);
    const next = exists ? favorites.filter(item => item !== id) : [...favorites, id];
    if (!save(KEY, next)) return;
    const urls = getUrls();
    if (button.dataset.productUrl) { urls[id] = button.dataset.productUrl; save(URL_KEY, urls); }
    syncButtons();
    document.dispatchEvent(new CustomEvent('sd:favorites-updated', { detail: { favorites: next } }));
  }
  function createElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }
  function formatPrice(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(Number(cents || 0) / 100);
  }
  async function fetchProduct(url) {
    const parsed = new URL(url, location.origin);
    if (parsed.origin !== location.origin) throw new Error('Domaine différent');
    const match = parsed.pathname.match(/\/products\/([^/]+)/);
    if (!match) throw new Error('URL produit invalide');
    const prefix = parsed.pathname.substring(0, parsed.pathname.indexOf('/products/'));
    const response = await fetch(prefix + '/products/' + match[1] + '.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Produit inaccessible');
    return response.json();
  }
  function makeCard(product, id, url) {
    const card = createElement('article', 'sd-favorites-card');
    const media = createElement('div', 'sd-favorites-card__media');
    const imageLink = createElement('a', 'sd-favorites-card__image');
    imageLink.href = url;
    const image = document.createElement('img');
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = product.title || 'Tapis';
    image.src = product.featured_image || (product.images && product.images[0]) || '';
    imageLink.append(image);

    const remove = createElement('button', 'sd-favorite-button sd-favorite-button--card sd-favorites-card__heart');
    remove.type = 'button';
    remove.dataset.sdFavorite = '';
    remove.dataset.productId = id;
    remove.dataset.productUrl = url;
    remove.dataset.productTitle = product.title || 'Tapis';
    remove.setAttribute('aria-pressed', 'true');
    remove.setAttribute('aria-label', 'Retirer des favoris : ' + (product.title || 'ce tapis'));
    remove.title = 'Retirer des favoris';
    remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    media.append(imageLink, remove);

    const title = createElement('a', 'sd-favorites-card__title', product.title || 'Tapis');
    title.href = url;
    const price = createElement('div', 'sd-favorites-card__price');
    const minPrice = Number(product.price_min ?? product.price ?? 0);
    const from = Boolean(product.price_varies || Number(product.price_max ?? minPrice) > minPrice);
    price.append(createElement('span', 'sd-favorites-card__price-current', (from ? 'Dès ' : '') + formatPrice(minPrice)));

    // On affiche un prix barré uniquement s'il existe une comparaison fiable
    // pour une variante au prix affiché (pas un faux rabais).
    const minVariant = (product.variants || []).find(v => Number(v.price) === minPrice && Number(v.compare_at_price || 0) > Number(v.price));
    if (minVariant) {
      price.append(createElement('s', 'sd-favorites-card__price-old', formatPrice(minVariant.compare_at_price)));
    }
    card.append(media, title, price);
    return card;
  }
  async function renderPage() {
    const sequence = ++renderSequence;
    const page = document.querySelector('[data-sd-favorites-page]');
    if (!page) return;
    const grid = page.querySelector('[data-sd-favorites-grid]');
    const empty = page.querySelector('[data-sd-favorites-empty]');
    const loading = page.querySelector('[data-sd-favorites-loading]');
    const count = page.querySelector('[data-sd-favorites-count]');
    if (!grid || !empty || !loading || !count) return;
    const favorites = getFavorites();
    const urls = getUrls();
    grid.replaceChildren();
    grid.hidden = true; empty.hidden = true; count.hidden = true; loading.hidden = false;
    page.querySelectorAll('.sd-favorites-page__notice').forEach(n => n.remove());
    if (!favorites.length) { loading.hidden = true; empty.hidden = false; return; }
    const results = await Promise.all(favorites.map(async id => {
      if (!urls[id]) return { id, missing: true };
      try { return { id, product: await fetchProduct(urls[id]), url: urls[id] }; }
      catch (e) { return { id, missing: true }; }
    }));
    if (!page.isConnected || sequence !== renderSequence) return;
    let displayed = 0, missing = 0;
    results.forEach(result => {
      if (result.product) { grid.append(makeCard(result.product, result.id, result.url)); displayed++; }
      else missing++;
    });
    loading.hidden = true; count.hidden = false;
    count.textContent = favorites.length + (favorites.length > 1 ? ' tapis enregistrés' : ' tapis enregistré');
    if (displayed) grid.hidden = false;
    if (missing) {
      const notice = createElement('p', 'sd-favorites-page__notice', missing + ' ancien(s) favori(s) sans lien produit. Retrouve ces tapis dans les collections et clique sur leur cœur pour les retirer puis les ajouter à nouveau.');
      grid.after(notice);
    }
    if (!displayed && !missing) empty.hidden = false;
    syncButtons();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sd-favorite]');
    if (!button) return;
    event.preventDefault(); event.stopPropagation(); toggle(button);
  });
  document.addEventListener('sd:favorites-updated', renderPage);
  document.addEventListener('DOMContentLoaded', () => { syncButtons(); renderPage(); });
  document.addEventListener('shopify:section:load', () => { syncButtons(); renderPage(); });
  window.addEventListener('storage', event => {
    if (event.key === KEY || event.key === URL_KEY) { syncButtons(); renderPage(); }
  });
  function watchNewFavoriteButtons() {
    new MutationObserver(records => {
      const hasNewButtons = records.some(record => Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches('[data-sd-favorite]') || node.querySelector('[data-sd-favorite]'))
      ));
      if (hasNewButtons) syncButtons();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchNewFavoriteButtons, { once: true });
  } else {
    watchNewFavoriteButtons();
  }
  window.SDFavorites = { get: getFavorites, refresh: syncButtons, renderPage };
})();
